// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"patientLabResultPage_wrapper__2rQ31","content":"patientLabResultPage_content__12_dk"};